export default "__VITE_ASSET__CPziX0fQ__"